import React, { useEffect, useState } from 'react';
import { Container, Row, Card, Col, Alert, Spinner, Popover, Form } from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';
import { ActionType } from '../../helpers/Enum/index';
import { DashboardOutlined, InfoOutlined } from '@material-ui/icons';
import Chart from 'react-apexcharts';
import * as CurrencyFormat from 'react-currency-format';
import * as iconRevenueColor from '../../images/revenue-color.png';
import * as iconPercentageFundsColor from '../../images/percent-funds-color.png';
import { parseDateBR } from 'helpers/date';
import { collect } from 'collect.js';
import CnaesRequestService from 'services/cnaes-request';
import CardBanner from 'components/CardBanner';
import DashboardRequestService from 'services/dashboard-request';
import CardTab from 'components/CardTab';
import { NotificationsActiveOutlined } from '@material-ui/icons';
import CardFundScancashMinimalist from 'components/CardFundDB/CardFundScancashMinimalist';
import NewNotification from 'services/new_notification-request';


import { Link } from 'react-router-dom';
import Can from 'components/Can';
import { useCompany, useUser } from 'models';
import { useFiscalYearsList } from 'helpers';

function is_premium_by_year(year){
  let r = {
    "12":3,
    "13":4,
    "14":5
  }

  return r[year]
}

const ResaleView = ({ user, currentCompany }) => {
  const [company, setCompany] = useState({
    programs: [],
    ranking: {},
    funds: { '1': {}, '2': {}, '3': {} },
  });
  const [bus, setBus] = useState([]);
  const [accelerator, setAccelerator] = useState({});
  const [valueToNextAccelerator, setValueToNextAccelerator] = useState(0)

  const [revenueDate, setRevenueDate] = useState('');

  const [sellerId, setSellerId] = useState(null);

  const [graphManufacturers, setGraphManufacturers] = useState([]);
  const [graphByMonth, setGraphByMonth] = useState([]);
  const [graphCompareLast, setGraphCompareLast] = useState([]);
  const [graphBySection, setGraphBySection] = useState([]);
  const [graphRankingByMonths, setGraphRankingByMonths] = useState([]);
  const [notifications, setNotifications] = useState([])
  const [technologies, setTechnologies] = useState([])
  const [loadingNotifications, setLoadingNotifications] = useState(false)

  const [isLoading, setIsLoading] = useState({
    inovation: false,
    scancash: false,
    accelerators: true
  })

  const fiscalYears = useFiscalYearsList()

  const [fiscalYear, setFiscalYear] = useState(() => {
    return fiscalYears[0];
  });

  useEffect(() => {
    getCompany(currentCompany.id, fiscalYear.id);
    getRevenuesDate();
    changeFiscalYear(fiscalYear.id);
    getNotifications()
    getRankingTechnologies()
  }, [fiscalYear]);

  useEffect(() => {
    if (company.ranking_accelerator && !accelerator.order) {
      getAccelerator();
    }
  }, [company])

  const getCompany = (id, fiscal_year_id = null) => {
    let filters = {
      ranking_type: 1,
      ranking_type_accelerator: 1, // teste fixo
      fiscal_year_id: fiscal_year_id,
    };
    if (id) filters['id'] = id;

    let result = ResalesRequestService.getCompanyFunds(id, {
      params: { ...filters },
    });
    result.then(({ data }) => {
      let res = data.data;
      setValueToNextAccelerator(res.value_next_accelerator)

      //funds
      let funds = {};
      if (res.funds) {
        res.funds.filter(a => a.business_unity_id == 3).forEach((fund) => {
          let sum = 0;
          fund.actions
            .filter((item) => {
              return item.action_status_id != 10;
            })
            .forEach((item) => {
              sum += item.pivot.value;
            });
          if (!funds[fund.type_id]) funds[fund.type_id] = {};
          funds[fund.type_id][fund.name] = parseFloat(fund.pivot.value).toFixed(2) - parseFloat(sum).toFixed(2);
        });

        funds['rebate_total'] = funds[ActionType().Rebate]
          ? Object.values(funds[ActionType().Rebate]).reduce((total, value) => {
            return total + value;
          }, 0)
          : 0;
        funds['mktdes_total'] = funds[ActionType().Marketing]
          ? Object.values(funds[ActionType().Marketing]).reduce(
            (total, value) => {
              return total + value;
            }, 0)
          : 0;
      } else {
        funds[ActionType().Marketing] = {};
        funds[ActionType().Rebate] = {};
        funds[ActionType().Marketing]['mkt'] = 0;
        funds[ActionType().Marketing]['des_merc'] = 0;
        funds[ActionType().Rebate]['rebate'] = 0;
        funds['rebate_total'] = 0;
        funds['mktdes_total'] = 0;
      }
      res.funds = funds;
      getGraph(res);
      getRevenuesDate(fiscalYear.id);
      setCompany(res);
      CnaesRequestService.getSectionByCompany({
        params: {
          company_id: res.id,
          fiscal_year_id: fiscalYear.id ?? company.fiscal_year[company.fiscal_year - 1].id
        }
      }).then(({ data }) => {
        setGraphBySection(data.sort(function (a, b) {
          var keyA = a.value,
            keyB = b.value;
          // Compare the 2 dates
          if (keyA > keyB) return -1;
          if (keyA < keyB) return 1;
          return 0;
        }));
      });
    });
  };

  const getBus = (area_id) => {
    let request = ResalesRequestService.getBus({
      params: {},
    });
    request.then((data) => {
      setBus(data.data.data);
    });
  };

  const getRevenuesDate = (date) => {
    let request = ResalesRequestService.getLastDateRevenue({
      params: {
        date: date,
        company_id: currentCompany.id
      }
    });
    request.then((data) => {
      setRevenueDate(data.data.last_date);
    });
  };

  const getRankingTechnologies = () => {
    const request = DashboardRequestService.getRankingTechnologies(currentCompany.id)
    request.then(({ data }) => {
      setTechnologies(data)
    })
  }

  const getAccelerator = () => {
    setIsLoading(old => ({
      ...old,
      accelerator: true
    }))

    let request = ResalesRequestService.getAcceleratorsByCategory({
      params: {
        sort_by: 'order',
        __is_premium: is_premium_by_year(fiscalYear.id)
      },
    });

    request.then(({ data: response }) => {
      const premiumCondition = (currentCompany.current_fiscal_year.programs??[]).map(a=>a.premium_id);

      const filtered = response.filter(ac => {
        if (premiumCondition.includes(currentCompany.is_premium)) {
          return ac.premium == currentCompany.is_premium
        }
        return !ac.premium;
      })
        .filter(ac => {
          return ac.order == currentCompany.ranking_accelerator.accelerator
        })[0]

      const { order, percentage } = filtered ?? {}
      setAccelerator({ order, percentage });
    })
      .finally(() => setIsLoading(old => ({
        ...old,
        accelerator: false
      })));
  };

  const getGraph = (company) => {

    if (!company.group_years) {
      return
    }

    const groupIds = company.group_years
      .filter(item => item.fiscal_year_id == fiscalYear.id)
      .map(item => item.company_id)

    var sellerId = company.id
    let filters = {};
    if (sellerId) {
      filters['__group_ids'] = JSON.stringify(groupIds)
      filters['__seller_id'] = sellerId;
    }

    //Manufacturers
    let rm = ResalesRequestService.getByManufacturerDash({
      params: {
        ...filters,
        fiscal_year_id: fiscalYear.id ?? company.fiscal_year[company.fiscal_year - 1].id
      },
    });
    rm.then((data) => {
      let result = data.data.data;
      let total = 0;
      let lista = {};
      result.forEach((brand) => {
        total += brand.value;
        if (lista[brand.manufacturer]) {
          lista[brand.manufacturer] += brand.value;
        } else {
          lista[brand.manufacturer] = brand.value;
        }
      });
      setGraphManufacturers(lista);
    });

    //ByMonth
    getRevenuesByMonth(sellerId, null, setGraphByMonth);

    //CompareLast
    let rcl = ResalesRequestService.getCompareLast({
      params: { ...filters, fiscal_year_id: fiscalYear.id },
    });
    rcl.then((data) => {
      let aux = data.data.data;
      setGraphCompareLast([...aux]);
    });
  };

  const getRevenuesByMonth = (seller_id, premium, set) => {
    let filters = {};
    if (seller_id) filters['seller_id'] = seller_id;

    filters['premium'] = premium;
    filters['sort_by'] = 'month';
    filters['fiscal_year_id'] = fiscalYear.id;
    let result = ResalesRequestService.getCompanyByMonth({
      params: { ...filters },
    });
    result.then((data) => {
      set(data.data);
    });
  };

  const getSeriesForGraph = () => {
    let anoFiscal = graphCompareLast[0];
    if (anoFiscal) {
      let key = Object.keys(anoFiscal).filter((a) => {
        return a !== 'period';
      });
      return key.map((a) => {
        return {
          name: a,
          data: graphCompareLast.map((v) => {
            return v[a];
          }),
        };
      });
    }

    return [
      {
        name: 'FY19',
        data: graphCompareLast.map((v) => {
          return v[2019];
        }),
      },
      {
        name: 'FY20',
        data: graphCompareLast.map((v) => {
          return v[2020];
        }),
      },
    ];
  };

  const getTitleGraph = () => {
    let anoFiscal = graphCompareLast[0];
    if (anoFiscal) {
      let key = Object.keys(anoFiscal).filter((a) => {
        return a !== 'period';
      });
      return (
        'Evolução e compras ( ' +
        key
          .map((a) => {
            return 'FY' + a.substring(a.length - 2);
          })
          .join(' | ') +
        ' )'
      );
    }

    return 'Evolução e compras';
  };

  const showMemberSince = () => {
    if (collect(currentCompany.fiscal_years_elite).where('id', Number(fiscalYear.id)).count() > 0 ||
      collect(currentCompany.fiscal_years_scancash).where('id', Number(fiscalYear.id)).count() > 0
    ) {
      return true;
    }
    return false;
  }

  const changeFiscalYear = (id) => {
    const filter = {
      fiscal_year_id: id,
      company_id: currentCompany.id
    };
    let companies = ResalesRequestService.getGroupHeadquarter({
      params: { ...filter },
    });
    companies.then((data) => {
      let c = data.data.data;
      if (c.company_group_id) {
        let r = ResalesRequestService.getByGroup({
          params: { company_group_id: c.company_group_id, fiscal_year_id: parseInt(id) },
        });
        r.then((data) => {
          setSellerId(
            data.data
              .map((d) => {
                return d.company_id;
              })
              .join()
          );
        });
      } else {
        setSellerId(c.company_id)
      }

      //setFiscalYear(id);
      showMemberSince();
      getCompany(c.company_id, id);
    });
  }

  const getProps = () => {
    const minWidth = 440;
    const isMobile = window.innerWidth <= minWidth;

    let retorno = {};
    if (!isMobile) {
      retorno.width = 340;
    }

    return retorno;
  }

  const getNotifications = () => {
    setLoadingNotifications(true)
    NewNotification.fetchByCompany(currentCompany.id)
      .then(res => {
        setNotifications(res.data.map((item) => ({ ...item.notification, company_id: item.company_id, entity_id: item.id })))
      })
      .finally(() => {
        setLoadingNotifications(false)
      })


    // NotificationRequestService.notification({ 
    //   params: { 
    //     per_page: 10,
    //     is_last_messages: 1,
    //     company_id: currentCompany.id
    //   }
    // })
    // .then(({ data: response }) => {
    //   const { data } = response
    //   if(data)
    //     setNotifications(data)
    // })
    // .finally(() => {
    //   setLoadingNotifications(false)
    // })
  }

  const priorityLabel = n => {
    const arr = [
      { variant: 'success', label: 'Mais Baixa' },
      { variant: 'info', label: 'Baixa' },
      { variant: 'warning', label: 'Alerta' },
      { variant: 'danger', label: 'Urgente' }
    ]
    return arr[n]
  }

  const getNotificationTime = (date) => {
    const getObjectDate = (date) => {
      let aux = date.split(' ');
      let data = aux[0].split('-');
      let hora = aux[1].split(':');

      let retorno = new Date(data[0], data[1] - 1, data[2], hora[0], hora[1], hora[2]);
      return new Date(retorno.setHours(retorno.getHours() - 3));
    }

    const calc = (d1, d2) => {
      let dif = d1 - d2;
      // calc segundos
      dif = dif / 1000;
      if (dif < 60) return 'há pouco tempo';
      // calc minutos
      dif = dif / 60;
      if (dif < 60) return `há ${parseInt(dif)} minuto` + (parseInt(dif) > 1 ? 's' : '');
      // calc horas
      dif = dif / 60;
      if (dif < 24) return `há ${parseInt(dif)} hora` + (parseInt(dif) > 1 ? 's' : '');
      // calc dias
      dif = dif / 24;
      if (dif < 7) return `há ${parseInt(dif)} dia` + (parseInt(dif) > 1 ? 's' : '');
      // calc semanas
      dif = dif / 7;
      if (dif < 4) return `há ${parseInt(dif)} semana` + (parseInt(dif) > 1 ? 's' : '');
      // calc meses
      dif = dif / 4;
      if (dif < 12) return `há ${parseInt(dif)} ` + (parseInt(dif) > 1 ? 'meses' : 'mês');
      // calc anos
      dif = dif / 12;
      return `há ${parseInt(dif)} ano` + (parseInt(dif) > 1 ? 's' : '');
    };

    let dateNotidication = getObjectDate(date);
    let dateNow = new Date();
    return calc(dateNow.getTime(), dateNotidication.getTime());
  }

  const getClassificationLabel = is_premium => {
    switch (is_premium) {
      case 0:
        return 'Outros'
        break;
      case 1:
        return "Elite"
        break
      case 2:
        return "Elite-Gerencial"
        break
      case 3:
        return "ScanCash"
        break;
    }
  }

  const popoverComponent = id => (
    <Popover id={`popover-${id}`}>
      <Popover.Header as="h3">Popover right</Popover.Header>
      <Popover.Body>
        And here's some <strong>amazing</strong> content. It's very engaging.
        right?
      </Popover.Body>
    </Popover>
  )

  const nivelFaturamento = () => {
    return (
      <Col md="12" className="pl-1 pr-1">
        <Card.Body className="card-dashboard shadow bg-white rounded text-center h-100 w-100">
          <Col md="12" className="text-left">
            <span className="dashboard-card-h5">
              Nível de faturamento
            </span>
          </Col>
          <Col md="12">
            <hr></hr>
          </Col>
          <Row className="text-center mb-4 mt-2">
            <Col md="12">
              <Row>
                <Col md="12">
                  <h5 className="text-h5 font-weight-bold d-block pt-2 mt-0 mb-0">
                    Acelerador {accelerator.order ?? '-'}
                  </h5>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md="4" className="text-center b-0 p-0 box d-inline-block">
                  <div className="border border-white m-2 mt-1">
                    <img
                      className="icon-funds"
                      src={iconRevenueColor}
                      width="40"
                    />
                    <p className="dashboard-card-h5 mt-1 mb-0">Faturamento</p>
                    <h5 className="text-h5 font-weight-bold d-block pt-2 mt-0 mb-0">
                      {isLoading.accelerator ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <CurrencyFormat
                          thousandSeparator="."
                          decimalSeparator=","
                          prefix="R$ "
                          maxLength={17}
                          max="999999999.99"
                          fixedDecimalScale={true}
                          decimalScale={2}
                          displayType={'text'}
                          value={
                            company.ranking_accelerator
                              ? company.ranking_accelerator.value
                              : ''
                          }
                        />
                      )}
                    </h5>
                  </div>
                </Col>
                <Col
                  md="4"
                  className="text-center b-0 p-0 box d-inline-block"
                >
                  <div className="border border-white m-2 mt-1">
                    <img
                      className="icon-funds"
                      src={iconPercentageFundsColor}
                      width="40"
                    />
                    <p className="dashboard-card-h5 mt-1 mb-0">
                      Fundos percentuais até
                    </p>
                    <h5 className="text-h5 font-weight-bold d-block pt-2 mt-0 mb-0">
                      {isLoading.accelerator ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {`${accelerator.percentage ?? ""} %`}
                      </>)}
                    </h5>
                  </div>
                </Col>
                <Col md="4" className="text-center b-0 p-0 box d-inline-block" >
                  <div className="border border-white m-2 mt-1">
                    <img
                      className="icon-funds"
                      src={iconPercentageFundsColor}
                      width="40"
                    />
                    <p className="dashboard-card-h5 mt-1 mb-0">
                      Valor a faturar para upgrade de acelerador
                    </p>
                    <h5 className="text-h5 font-weight-bold d-block pt-2 mt-0 mb-0">
                      {isLoading.accelerator ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<CurrencyFormat
                        thousandSeparator="."
                        decimalSeparator=","
                        prefix="R$ "
                        maxLength={17}
                        max="999999999.99"
                        fixedDecimalScale={true}
                        decimalScale={2}
                        displayType={'text'}
                        value={valueToNextAccelerator}
                      />)}
                    </h5>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Col>
    );
  }

  function getNameByYear(fiscalYear){
    let premium = currentCompany.getYearData(fiscalYear).is_premium;
    if(premium == 4){
      return "Elite Pass";
    }
    if(premium == 5){
      return "ScanSource Select";
    }

    return "Dashboard";
  }

  return (
    <>
      <Container>
        <Row className="mt-4 mb-2">
          <Col className="d-flex p-0">
            <DashboardOutlined className="icon-title" />
            <h5 className="title-dashboard">
              {getNameByYear(fiscalYear.id)} - {currentCompany.company_name}
            </h5>
          </Col>
          <div className="d-flex align-items-center">
            <Form.Control value={fiscalYear.id} size='sm' as="select" onChange={(e) => {
              const fy = fiscalYears.filter(fy => fy.id == e.target.value)[0]
              //localStorage.setItem("Elite:fiscalYear", JSON.stringify(fy))
              setFiscalYear(fy)
            }}>
              {fiscalYears.map((fy, idx) => (
                <option value={fy.id} selected={idx == 0}>{fy.fiscal_year}</option>
              ))}
            </Form.Control>
          </div>
          {showMemberSince() ? (
            <>
              <Col md="auto" className="text-right float-right mt-2">
                <h6 className="dashboard-info d-contents">
                  Parceiro desde: {currentCompany.premium_since ? parseDateBR(currentCompany.premium_since) : '-'}
                </h6>
              </Col>

              <Col md="auto" className="text-right float-right mt-2">
                <h6 className="dashboard-info d-contents">
                  Data atualização:{' '}
                  {revenueDate ? parseDateBR(revenueDate) : '-'}
                </h6>
              </Col>
            </>
          ) : (
            ''
          )}
        </Row>
        <Row>
          <Col xs="12" md="8" className='mb-2'>
            <Row>
              <Col md="12" className="mb-1">
                <CardFundScancashMinimalist fiscalYear={fiscalYear.id} companyId={currentCompany.id} />
                {/* <Row className="h-100">
                  <Col md={technologies.length > 0 ? 4 : 6} className="pl-1 pr-1 mb-1">
                    <Card.Body className="card-dashboard shadow bg-white rounded d-flex align-items-center justify-content-center flex-column h-100 w-100">
                      <h4 className="dashboard-card-h5">
                        Posição ScanSource
                      </h4>
                      <h4 className="text-h5 font-weight-bold d-block pt-2 mb-0">
                        {!currentCompany.ranking_position ? (currentCompany.ranking?currentCompany.ranking.position:0): currentCompany.ranking_position}º
                      </h4>
                    </Card.Body>
                  </Col>
                  <Col md={technologies.length > 0 ? 4 : 6} className="pl-1 pr-1 mb-1">
                    <Card.Body className="card-dashboard shadow bg-white rounded d-flex align-items-center justify-content-center flex-column  h-100 w-100">
                      <h4 className="dashboard-card-h5">
                        Classificação
                      </h4>
                      <h4 className="text-h5 font-weight-bold d-block pt-2 mb-0">
                        {getClassificationLabel(currentCompany.is_premium)}
                      </h4>
                    </Card.Body>
                  </Col>
                  {technologies.length > 0 ? (
                    <Col md="4" className="pl-1 pr-1 mb-1 card-ranking-tech">
                      <Card className="card-dashboard shadow bg-white rounded h-100 w-100">
                        <Card.Header className="card-header-custom">Ranking por Tecnologia</Card.Header>
                        <Card.Body className="card-body-np p-1">
                          <Carousel
                            controls={technologies.length > 1}
                            fade
                          >
                            {technologies.map(t => {
                              return (
                                <Carousel.Item key={t.ranking_id}>
                                  <Carousel.Caption>
                                    <h3 className="dashboard-card-h5">{t.technology_name}</h3>
                                    <p className="text-h5 font-weight-bold d-block pt-1 mb-0">{`${t.position}º`}</p>
                                  </Carousel.Caption>
                                </Carousel.Item>
                              )
                            })}                                                  
                          </Carousel>
                        </Card.Body>
                      </Card>
                    </Col>
                  ) : (<></>)}
                </Row> */}
              </Col>
              {!fiscalYear ? nivelFaturamento() : (fiscalYear.id === user.fiscal_years[user.fiscal_years.length - 1].id ? nivelFaturamento() : <></>)}
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs="12" md="12">
                <Row>
                  {fiscalYear.id == 12 && (
                    <Col className='mb-2 pl-1 pr-1' xs="12">
                      <Link to="/elite/scancash/fund">
                        <Card.Body className="card-dashboard shadow bg-white rounded w-100 p-3 click-card" style={{ position: "relative", minHeight: "110px" }}>
                          Extrato de Verbas - Scancash
                        </Card.Body>
                      </Link>
                    </Col>
                  )}
                  {fiscalYear.id == 13 && (
                    <Col className='mb-2 pl-1 pr-1' xs="12">
                      <Link to="/elite/elite-pass/fund">
                        <Card.Body className="card-dashboard shadow bg-white rounded w-100 p-3 click-card" style={{ position: "relative", minHeight: "110px" }}>
                          Extrato de Verbas - Elite Pass
                        </Card.Body>
                      </Link>
                    </Col>
                  )}
                  {fiscalYear.id == 14 && (
                    <Col className='mb-2 pl-1 pr-1' xs="12">
                      <Link to="/elite/scansource-select/fund">
                        <Card.Body className="card-dashboard shadow bg-white rounded w-100 p-3 click-card" style={{ position: "relative", minHeight: "110px" }}>
                          Extrato de Verbas - ScanSource Select
                        </Card.Body>
                      </Link>
                    </Col>
                  )}
                </Row>
              </Col>
              <CardTab xs="12" md="12" type={1} title={<><NotificationsActiveOutlined /> Notificações</>}
                load={loadingNotifications}
                list={notifications.map((item) => {
                  let v = priorityLabel(item.priority)
                  return {
                    title: item.title,
                    entity_id: item.entity_id,
                    content: <p dangerouslySetInnerHTML={{ __html: `${item.content}`.replaceAll("\r\n", "<br>") }} />,
                    tag: { text: v.label, variant: v.variant },
                    notification_id: item.id,
                    company_id: item.company_id,
                    force:item.type != 1
                  }
                })}
              />
            </Row>
          </Col>
        </Row>
        <CardBanner />
        <Row>
          <Col className="p-1 pb-2" xl="6" lg="6" md="6">
            <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100">
              <Row>
                <Col md="12">
                  <span className="dashboard-card-h5 text-left">
                    Compras por marca
                  </span>
                </Col>
                <Col md="12">
                  <hr className="mt-0"></hr>
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="12">
                  <Chart
                    width="500"
                    type='pie'
                    options={{
                      labels: Object.keys(graphManufacturers).map((k) => {
                        return k;
                      }),
                      tooltip: {
                        y: {
                          formatter: function (d) {
                            return d.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                          },
                        },
                      }
                    }}
                    series={Object.keys(graphManufacturers).map((k) => {
                      return graphManufacturers[k];
                    })}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Col>
          <Col className="p-1 pb-2" xl="6" lg="6" md="6">
            <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100">
              <Col md="12">
                <span className="dashboard-card-h5 text-left">
                  Faturamento mensal
                </span>
              </Col>
              <Col md="12">
                <hr></hr>
              </Col>
              <Col md="12">
                <Chart
                  options={{
                    xaxis: {
                      type: 'datetime',
                      categories: graphByMonth.map((v) => {
                        return v.month;
                      }),
                      labels: {
                        format: 'MM/yyyy',
                      },
                    },
                    yaxis: {
                      labels: {
                        formatter: function (d) {
                          return d
                            ? 'R$ ' +
                            d.toLocaleString("pt-br", {
                              minimumFractionDigits: 2,
                            })
                            : '';
                        },
                      }
                    },
                    responsive: [
                      {
                        breakpoint: 480,
                        options: {
                          yaxis: {
                            labels: {
                              formatter: function (d) {
                                const nome = (valor) => {
                                  switch (valor.split('.').length) {
                                    case 2:
                                      return 'mil'
                                      break;
                                    case 3:
                                      return 'mi'
                                      break;
                                    case 4:
                                      return 'bi'
                                      break;
                                    default:
                                      return ''
                                      break;
                                  }
                                }
                                let valor = d ? d.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                }) : '';
                                return valor
                                  ? 'R$ ' +
                                  valor.split('.')[0] + ' ' + (nome(valor))
                                  : '';
                              },
                            },
                          },
                        },
                      },
                    ],
                    tooltip: {
                      x: {
                        type: 'datetime',
                        format: 'MM/yyyy',
                      },
                    },
                    stroke: {
                      curve: 'smooth',
                    },
                  }}
                  series={[
                    {
                      name: 'Faturamento',
                      data: graphByMonth.map((v) => {
                        return v.value;
                      }),
                    },
                  ]}
                  type="line"
                  height={250}
                />
              </Col>
            </Card.Body>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ResaleView;
